export function formatPrice(value: number, fractions: number = 2): string {
    return value.toLocaleString('de-DE', {minimumFractionDigits: fractions})
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/NumberHelper.ts